
import { Panel } from '@/ui/components/Panel';
import { Icon } from '@/ui/icons/Icon';
import type { HMIComponentType } from '@/hmi/model/types';
import { useHMIEditorStore } from './store/hmiEditorStore';
import styles from './HMIToolbox.module.css';

const HMI_COMPONENTS: { type: HMIComponentType; label: string; icon: string; width?: number; height?: number }[] = [
  { type: 'Text', label: 'Text / Label', icon: 'list', width: 100, height: 40 },
  { type: 'PushButton', label: 'Push Button', icon: 'power', width: 100, height: 40 },
  { type: 'PilotLamp', label: 'Pilot Lamp', icon: 'lamp', width: 60, height: 60 },
  { type: 'CoolingFan', label: 'Cooling Fan', icon: 'fan', width: 80, height: 80 },
  { type: 'MotorStatus', label: 'Motor Status', icon: 'motor', width: 120, height: 80 },
  { type: 'NumericDisplay', label: 'Numeric Display', icon: 'mode-monitor', width: 100, height: 40 },
  { type: 'LinearGauge', label: 'Linear Gauge', icon: 'mode-simulation', width: 50, height: 120 },
  { type: 'TankLevel', label: 'Tank Level', icon: 'water', width: 80, height: 120 },
  { type: 'BarGraph', label: 'Bar Graph', icon: 'mode-monitor', width: 80, height: 120 },
  { type: 'AlarmBanner', label: 'Alarm Banner', icon: 'bell', width: 200, height: 40 },
  { type: 'NavigationButton', label: 'Navigation Button', icon: 'mode-design', width: 120, height: 40 },
];

export function HMIToolbox() {
  const { addComponent } = useHMIEditorStore();

  return (
    <Panel label="HMI Components" className={styles.panel}>
      <div className={styles.grid}>
        {HMI_COMPONENTS.map((comp) => (
          <div
            key={comp.type}
            className={styles.item}
            onClick={() => {
              addComponent({
                type: comp.type,
                x: 100,
                y: 100,
                width: comp.width ?? 100,
                height: comp.height ?? 40,
                binding: { type: 'NONE', address: '' },
                props: { label: comp.label }
              });
            }}
          >
            <Icon name={comp.icon} size={24} />
            <span className={styles.label}>{comp.label}</span>
          </div>
        ))}
      </div>
    </Panel>
  );
}
